import { XmlSchemaFacet } from './XmlSchemaFacet';

export class XmlSchemaMaxExclusiveFacet extends XmlSchemaFacet {}
